import { render } from "./CallStatusPerLabelBarChart.vue?vue&type=template&id=346d0e68&ts=true"
import script from "./CallStatusPerLabelBarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallStatusPerLabelBarChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/CallStatusPerLabelBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "346d0e68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('346d0e68', __exports__)) {
    api.reload('346d0e68', __exports__)
  }
  
  module.hot.accept("./CallStatusPerLabelBarChart.vue?vue&type=template&id=346d0e68&ts=true", () => {
    api.rerender('346d0e68', render)
  })

}


export default __exports__